'use strict';


export class Effect {
  constructor () {}

  set active(state) {
    this.effect.enabled = state;
  }

  get active() {
    return this.effect.enabled;
  }

}
